import { cn } from "@/lib/utils";
import { STATUS, SURFACE, TYPE } from "@/design/tokens";

export const StatusBadge = ({ tone = "neutral", children, dot = true, className, ...rest }) => (
  <span
    className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", STATUS[tone].badge, className)}
    {...rest}
  >
    {dot && <span className={cn("h-1.5 w-1.5 rounded-full", STATUS[tone].dot)} />}
    {children}
  </span>
);

export const DemoBadge = ({ className, ...rest }) => (
  <span
    className={cn("inline-flex items-center rounded-full border border-dashed border-slate-300 bg-white px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-slate-600", className)}
    {...rest}
  >
    Dati dimostrativi
  </span>
);

export const SectionLabel = ({ children, className }) => (
  <p className={cn(TYPE.overline, className)}>{children}</p>
);

export const PageHeader = ({ overline, title, description, actions, testId }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-testid={testId}>
    <div className="animate-rise">
      {overline && <SectionLabel className="mb-2">{overline}</SectionLabel>}
      <h1 className={TYPE.h1}>{title}</h1>
      {description && <p className={cn("mt-1.5 max-w-2xl", TYPE.body, "text-slate-500")}>{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export const Panel = ({ className, children, ...rest }) => (
  <section className={cn(SURFACE.card, className)} {...rest}>
    {children}
  </section>
);
